import config from '@/config/index'
import { get } from 'lodash-es'
import { getLocalStorage } from '@/utils/localStorage'

export const mPassport = () => {
  return get(window, 'login', false)
}

export const isPC = () => {
  return get(document, 'body.clientWidth', 1156) > 768
}

let loginJs = null
export const getLoginJs = () => {
  if (loginJs) {
    return loginJs
  } else {
    const setConfigParams = {
      /* 基础参数 */
      appid: config.passport.appId,
      role: config.passport.role,
      city_id: config.passport.city_id,
      lang: config.passport.lang,
      country_calling_code: config.passport.country_calling_code,
      country_id: config.passport.country_id,
      ticket: getLocalStorage('ticket'),
      canonical_country_code: config.passport.canonical_country_code,
      extra_info: config.passport.extra_info,
      styleObj: {
        /* 自定义按钮及法律icon样式 */
        btn: {
          disableColor: '#999999',
          activeColor: '#fff',
          bgColor: '#ff7a45',
        },
        law: {
          color: '#ff7a45',
          iconBlue: true,
          marginRight: '12px',
        },
      },
    }
    loginJs = new Promise(resolve => {
      // const script = document.createElement('script')
      // script.src = config.passport.h5LoginUrl
      // document.body.appendChild(script)
      // script.onload = async function () {
      window.login.setConfig(setConfigParams)
      resolve(window.login)
      // }
    })
    return loginJs
  }
}
